import React, { Component } from 'react'
import EditAlertContentField from './EditAlertContentField'
import CategorySelection from './CategorySelection'
import { isEmpty } from "lodash"
import FormColumn from '../../../../Templates/FormColumn'
import Checkbox from '@material-ui/core/Checkbox';
export default class StepAlerts extends Component {

    constructor(props) {
        super(props);
        this.state = {
          showingFilter: false,
          filteringCategory: undefined,
          filteringStepId: undefined,
          infoItems: Object.keys(this.props.infoPage),
          infoPage : this.props.infoPage,
          selectedInfoItem: '',
          editingItem: '', // Store the item being edited
          editedAlertContent: '', // Add this state variable
          selectedStep: props.selectedStep,
          editedContentByItem: {},
          filteredInfoItems: [],
        };
      }

      componentDidMount=()=>{
        console.log("here")
        window.removeEventListener("beforeunload",()=>{this.runInfoPageCleanUp()})
        window.addEventListener("beforeunload",()=>{this.runInfoPageCleanUp()})
        // let page = this.props.getInfoPage()
        // this.setState({infoPage:page, infoItems:Object.keys(page)})
      }

    componentDidUpdate(prevProps) {
        // Check if the selectedStep prop has changed
        console.log("rerender")
        console.log(this.props)
        if (prevProps.selectedStep !== this.state.selectedStep) {
            this.setState({ selectedStep: this.state.selectedStep });
        }
    //     let ip = this.props.getInfoPage()
    //    this.setState({infoItems: Object.keys(this.props.getInfoPage())})  
    }



    componentWillUnmount = () => {
        this.runInfoPageCleanUp()
    }



    saveEditedAlertContent = (infoItem, editedContent) => {
        if (infoItem && editedContent !== '') {
            const infoPage = { ...this.props.infoPage };
            infoPage[infoItem].content = editedContent;
            this.props.updateInfoPage(infoPage);
        }
    };    


    // Update the click handler for rows to set the editingItem
    // handleRowClick = (infoItem) => {
    //     const { editingItem, editedContentByItem } = this.state;
    
    //     if (editingItem !== infoItem && editingItem !== '') {
    //         // Save the edited content for the previous row
    //         this.saveEditedAlertContent(editingItem, editedContentByItem[editingItem]);
    //     }
    
    //     this.setState({
    //         editingItem: infoItem,
    //         selectedInfoItem: infoItem,
    //         isEditing: true,
    //         editedAlertContent: editedContentByItem[infoItem] || this.props.infoPage[infoItem].content || '',
    //     });
    // };


    handleRowClick = (infoItem) => {
        const { editingItem, editedContentByItem } = this.state;
        if (editingItem !== infoItem && editingItem !== '') {
            // Save the edited content for the previous row
            this.saveEditedAlertContent(editingItem, editedContentByItem[editingItem]);
            const infoPage = { ...this.props.infoPage };
            this.props.updateInfoPage(infoPage);
        }
        this.setState({
            editingItem: infoItem,
            selectedInfoItem: infoItem,
            isEditing: true,
            editedAlertContent: editedContentByItem[infoItem] || this.props.infoPage[infoItem].content || '',
        });
    };



    addCategoryToInfoItem = (categoryName, infoItem) => {
        let infoPage = this.state.infoPage;
        console.log('HERE!! 1', infoPage[infoItem]);

        if (infoPage[infoItem].category !== categoryName) {
            infoPage[infoItem].category = categoryName;
            this.props.updateInfoPage(infoPage);
        }
        return;
    }

    // changeNameToInfoItem = (name, infoItem) => {
    //     let infoPage = this.props.infoPage
    //     if (infoPage[infoItem].category !== categoryName) {
    //         infoPage[infoItem].category = categoryName
    //         this.props.updateInfoPage(infoPage)
    //     }
    //     return
    // }



    addAlertToPage = () => {
        const { selectedStep } = this.state;
        let infoPage = this.state.infoPage;
        let i = 1;
        let found = false;
        let itemName;
      
        while (!found) {
          if (!infoPage[`nullStepItem${i}`]) {
            itemName = `nullStepItem${i}`;
            found = true;
            break;
          }
          i++;
        }
      
        infoPage[itemName] = { category: '', steps: [selectedStep._id] };
      
        this.props.updateInfoPage(infoPage);
        //const infoPageCopy = { ...this.state.infoPage }; // Create a shallow copy
        //infoPageCopy[itemName] = infoPage[itemName]
        this.setState({
          editingItem: itemName,
            infoItems: Object.keys(infoPage) ,
           infoPage: infoPage
        });
        // this.setState((prevState) => ({
        //   infoItems: [...prevState.infoItems, itemName],
        
        // }));
    };



    toggleItemToStep = (infoItem) => {
        let infoPage = this.props.infoPage
        let stepId = this.props.currentStep._id
        let newSteps
        if (infoPage[infoItem].steps.includes(stepId)) {
            newSteps = infoPage[infoItem].steps.filter(testid => testid !== stepId)
            infoPage[infoItem].steps = newSteps
        } else {
            infoPage[infoItem].steps.push(stepId)
        }
        this.props.updateInfoPage(infoPage)
    }



    removeItem = (infoItem) => {
        let infoPage = this.state.infoPage;
        let stepId = this.state.selectedStep._id;
        const { infoItems } = this.state;
        let newSteps;
        if (infoPage[infoItem].steps.length === 1) {
            delete infoPage[infoItem];
        } else {
            newSteps = infoPage[infoItem].steps.filter(testid => testid !== stepId);
            infoPage[infoItem].steps = newSteps;
        }
        this.props.updateInfoPage(infoPage);

        // Update the infoItems state to remove the deleted infoItem
        this.setState(prevState => ({
            infoItems: prevState.infoItems.filter(item => item !== infoItem),
        }));
    }



    editItemName = (infoItem, newName) => {
        const infoPageCopy = { ...this.state.infoPage }; // Create a shallow copy
        infoPageCopy[newName] = { ...infoPageCopy[infoItem] }; // Create a shallow copy of the item to ensure independence
        delete infoPageCopy[infoItem];
        
       this.setState({
           infoItems: Object.keys(infoPageCopy) ,
           infoPage: infoPageCopy
        },()=>{console.log(this.state)});

        // this.props.updateInfoPage(infoPageCopy);

    }
    

    runInfoPageCleanUp = () => {
        console.log("UNMOUNTING")
        let infoPage = this.state.infoPage
        // let infoItems = Object.keys(infoPage)

        this.state.infoItems.forEach(item => {
            if (item.includes("nullStepItem")) {
                delete infoPage[item]
            }
        })
        this.props.updateInfoPage(infoPage)
    }



    setFilter = (state, filter) => {
        if (state === "Category" && (!this.state.filteringCategory || this.state.filteringCategory !== filter)) {
            this.setState({ filteringCategory: filter, filteringStepId: undefined, filteringGlobal: undefined })
        } else if (state === "Step" && (!this.state.filteringStepId || this.state.filteringStepId !== filter)) {
            this.setState({ filteringStepId: filter, filteringCategory: undefined, filteringGlobal: undefined })
        } else {
            this.setState({ filteringStepId: undefined, filteringCategory: undefined, filteringGlobal: undefined })
        }
    }

    toggleGlobalItem = (itemIndex) => {
        let index = 0;
        let infoPage = this.props.infoPage

        for (let infoItem in infoPage) {
            if (index === itemIndex) {
                infoPage[infoItem].global = !infoPage[infoItem].global
            }
            index++
        }
        this.props.updateInfoPage(infoPage)
    }

    onEditContentChange=(infoItem,content)=>{
        console.log("saving step alert content")
        this.setState((prevState) => ({
            editedContentByItem: {
                ...prevState.editedContentByItem,
                [infoItem]: content,
            },
        }))
    }

    render = () => {
        const { infoItems, editingItem, selectedStep, selectedInfoItem } = this.state;
        const infoPage = this.state.infoPage
        const filteredInfoItems = infoItems.filter((item) => {
            const infoItemData = infoPage[item];
            return (
                infoItemData &&
                infoItemData.steps &&
                infoItemData.steps.includes(selectedStep._id)
            );
        });

        let categories = { "Cautions": { title: "Cautions" }, "Warnings": { title: "Warnings" }, "Notes": { title: "Notes" } }
        infoItems.forEach(infoItem => {
            const infoItemData = infoPage[infoItem];
            if (!infoItemData) {
                return; // Skip if infoItemData is undefined
            }

            let category = infoItemData.category;
            if (categories[category] || !category) {
                return;
            }
            categories[category] = { title: category };
        });

        if (this.state.filteringCategory) {
            infoItems = infoItems.filter(infoItem => {
                return infoPage[infoItem].category === this.state.filteringCategory
            });
        }

        if (this.state.filteringStepId) {
            infoItems = infoItems.filter((infoItem) => {
                return infoPage[infoItem].steps.includes(this.state.filteringStepId)
            });
        }

        const names = []
        const categorySelection = []
        const checkBoxes = []


        filteredInfoItems.forEach((infoItem, index) => {
            const isItemEditing = editingItem === infoItem;

// ----------------------------------------------------------------- Put Data In Here --------------------------------------------------------------------- //
            
            names.push(
                isItemEditing ? (
                    <li>
                    <EditAlertContentField
                        key={infoItem}
                        infoItem={infoItem}
                        editedContent={this.state.editedContentByItem[infoItem] || ''}
                        editItemName={this.editItemName}
                        cancel={() => this.setState({ editingItem: '', isEditing: false })}
                        editedAlertContent={this.state.editedContentByItem[infoItem] || ''}
                    /></li>
                ) : (
                    <li
                        key={this.state.editedContentByItem[infoItem] }
                        style={{ alignItems: 'center', justifyContent: 'flex-start'}}
                        onClick={() => this.setState({ editingItem: infoItem, isEditing: true })}
                    >
                        {/* <p className="ellipsis">{this.state.editedContentByItem[infoItem] === '' ? infoItem : this.state.editedContentByItem[infoItem] }</p> */}
                         <p className="ellipsis" style={{height: '28px', marginTop: '14px'}}>{infoItem}</p> 
                    </li>
                )
            );

            categorySelection.push(
                // <li>
                    <CategorySelection
                        key={`categorySelection-${infoItem}`}
                        categories={Object.values(categories)}
                        addCategoryToInfoItem={this.addCategoryToInfoItem}
                        category={infoPage[infoItem].category}
                        infoItem={infoItem}
                    />
                // </li>
            );
        
            checkBoxes.push(
                <div key={`checkBox-${infoItem}`} className="max-size flex-centered">
                    <Checkbox
                        onClick={() => this.setState({ selectedInfoItem: infoItem })}
                        checked={infoItem === this.state.selectedInfoItem}
                        color="primary"
                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                    />
                </div>
            );
        });
        
        

        //----------------------------------------------Will render 3 columns and 2 buttons to delete or create a step----------------------------------------------//
        
        return <div id="edit-step-alerts" className="flex max-width" style={{ height: "400px" }}>
            <div id="add-info-form-content-container" className="max-size">
                <ul className="flex overflow-y" id="info-items-list">
                    <FormColumn title={""} content={checkBoxes} nullSort columnWidth={"7%"} />
                    <FormColumn title={"Alert Content"} content={names} columnWidth={"60%"} fragments={true} />
                    <FormColumn title={"Category"} nullSort content={categorySelection} columnWidth={"45%"} />
                </ul>
                <div className="max-width leftWhiteBorder" style={{display: "flex", justifyContent: 'flex-end', height:"30px"}}>
                    <div  style={{marginLeft:"auto",marginRight:"auto"}}>
                        <svg style={{margin: "2.5px", height:"25px", width:"110px"}} className="clickable" onClick={this.addAlertToPage} width="175" height="33" viewBox="0 0 175 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="175" height="40" rx="5" fill="#F3F3F3" stroke="#081F5F" />
                            <path d="M28.4331 13.4741C29.9771 13.4741 31.1751 13.8809 32.0273 14.6943C32.8796 15.5078 33.3527 16.432 33.4468 17.4668H31.8364C31.6538 16.681 31.2886 16.0584 30.7407 15.5991C30.1984 15.1398 29.4347 14.9102 28.4497 14.9102C27.2489 14.9102 26.2777 15.3335 25.5361 16.1802C24.8001 17.0213 24.4321 18.3135 24.4321 20.0566C24.4321 21.4844 24.7642 22.6437 25.4282 23.5347C26.0978 24.4201 27.0939 24.8628 28.4165 24.8628C29.634 24.8628 30.5609 24.3952 31.1973 23.46C31.5348 22.9674 31.7866 22.32 31.9526 21.5176H33.563C33.4191 22.8014 32.9432 23.8778 32.1353 24.7466C31.1668 25.7925 29.8608 26.3154 28.2173 26.3154C26.8006 26.3154 25.6108 25.8866 24.6479 25.0288C23.3807 23.8944 22.7471 22.1429 22.7471 19.7744C22.7471 17.9759 23.223 16.5011 24.1748 15.3501C25.2041 14.0994 26.6235 13.4741 28.4331 13.4741ZM35.4224 17.1099H36.8418V18.6455C36.958 18.3467 37.243 17.9842 37.6968 17.5581C38.1506 17.1265 38.6735 16.9106 39.2656 16.9106C39.2933 16.9106 39.3403 16.9134 39.4067 16.9189C39.4731 16.9245 39.5866 16.9355 39.7471 16.9521V18.5293C39.6585 18.5127 39.5755 18.5016 39.498 18.4961C39.4261 18.4906 39.3459 18.4878 39.2573 18.4878C38.5047 18.4878 37.9264 18.7313 37.5225 19.2183C37.1185 19.6997 36.9165 20.2559 36.9165 20.8867V26H35.4224V17.1099ZM44.7441 16.9106C45.375 16.9106 45.9865 17.0601 46.5786 17.3589C47.1707 17.6522 47.6217 18.034 47.9316 18.5044C48.2305 18.9526 48.4297 19.4756 48.5293 20.0732C48.6178 20.4827 48.6621 21.1357 48.6621 22.0322H42.146C42.1737 22.9342 42.3867 23.6592 42.7852 24.207C43.1836 24.7493 43.8006 25.0205 44.6362 25.0205C45.4165 25.0205 46.0391 24.7632 46.5039 24.2485C46.7695 23.9497 46.9577 23.6038 47.0684 23.2109H48.5376C48.4989 23.5374 48.3688 23.9027 48.1475 24.3066C47.9316 24.7051 47.6882 25.0316 47.417 25.2861C46.9632 25.7288 46.4015 26.0277 45.7319 26.1826C45.3722 26.2712 44.9655 26.3154 44.5117 26.3154C43.4049 26.3154 42.467 25.9142 41.6978 25.1118C40.9285 24.3039 40.5439 23.175 40.5439 21.7251C40.5439 20.2974 40.9313 19.138 41.7061 18.2471C42.4808 17.3561 43.4935 16.9106 44.7441 16.9106ZM47.1265 20.8452C47.0656 20.1978 46.9245 19.6803 46.7031 19.293C46.2936 18.5736 45.6102 18.2139 44.6528 18.2139C43.9666 18.2139 43.3911 18.4629 42.9263 18.9609C42.4614 19.4535 42.2152 20.0815 42.1875 20.8452H47.1265ZM51.6504 23.6343C51.6504 24.0659 51.8081 24.4062 52.1235 24.6553C52.439 24.9043 52.8125 25.0288 53.2441 25.0288C53.7699 25.0288 54.279 24.9071 54.7715 24.6636C55.6016 24.2596 56.0166 23.5983 56.0166 22.6797V21.4761C55.834 21.5923 55.5988 21.6891 55.311 21.7666C55.0233 21.8441 54.741 21.8994 54.4644 21.9326L53.5596 22.0488C53.0173 22.1208 52.6105 22.2342 52.3394 22.3892C51.88 22.6493 51.6504 23.0643 51.6504 23.6343ZM55.2695 20.6128C55.6126 20.5685 55.8423 20.4246 55.9585 20.1812C56.0249 20.0483 56.0581 19.8574 56.0581 19.6084C56.0581 19.0993 55.8755 18.7313 55.5103 18.5044C55.1506 18.272 54.6331 18.1558 53.958 18.1558C53.1777 18.1558 52.6243 18.366 52.2979 18.7866C52.1152 19.019 51.9963 19.3649 51.9409 19.8242H50.5464C50.5741 18.7285 50.9282 17.9676 51.6089 17.5415C52.2951 17.1099 53.0892 16.894 53.9912 16.894C55.0371 16.894 55.8866 17.0933 56.5396 17.4917C57.187 17.8901 57.5107 18.5099 57.5107 19.3511V24.4727C57.5107 24.6276 57.5412 24.7521 57.6021 24.8462C57.6685 24.9403 57.804 24.9873 58.0088 24.9873C58.0752 24.9873 58.1499 24.9845 58.2329 24.979C58.3159 24.9679 58.4045 24.9541 58.4985 24.9375V26.0415C58.2661 26.1079 58.089 26.1494 57.9673 26.166C57.8455 26.1826 57.6795 26.1909 57.4692 26.1909C56.9546 26.1909 56.5811 26.0083 56.3486 25.6431C56.2269 25.4494 56.1411 25.1755 56.0913 24.8213C55.7869 25.2197 55.3498 25.5656 54.7798 25.8589C54.2098 26.1522 53.5817 26.2988 52.8955 26.2988C52.071 26.2988 51.3958 26.0498 50.8701 25.5518C50.3499 25.0482 50.0898 24.4201 50.0898 23.6675C50.0898 22.8429 50.3472 22.2038 50.8618 21.75C51.3765 21.2962 52.0516 21.0168 52.8872 20.9116L55.2695 20.6128ZM60.2666 14.6279H61.7773V17.1099H63.1968V18.3301H61.7773V24.1323C61.7773 24.4422 61.8825 24.6497 62.0928 24.7549C62.209 24.8158 62.4027 24.8462 62.6738 24.8462C62.7458 24.8462 62.8232 24.8462 62.9062 24.8462C62.9893 24.8407 63.0861 24.8324 63.1968 24.8213V26C63.0252 26.0498 62.8454 26.0858 62.6572 26.1079C62.4746 26.13 62.2754 26.1411 62.0596 26.1411C61.3623 26.1411 60.8892 25.964 60.6401 25.6099C60.3911 25.2502 60.2666 24.7853 60.2666 24.2153V18.3301H59.063V17.1099H60.2666V14.6279ZM68.4014 16.9106C69.0322 16.9106 69.6437 17.0601 70.2358 17.3589C70.828 17.6522 71.279 18.034 71.5889 18.5044C71.8877 18.9526 72.0869 19.4756 72.1865 20.0732C72.2751 20.4827 72.3193 21.1357 72.3193 22.0322H65.8032C65.8309 22.9342 66.0439 23.6592 66.4424 24.207C66.8408 24.7493 67.4578 25.0205 68.2935 25.0205C69.0737 25.0205 69.6963 24.7632 70.1611 24.2485C70.4268 23.9497 70.6149 23.6038 70.7256 23.2109H72.1948C72.1561 23.5374 72.026 23.9027 71.8047 24.3066C71.5889 24.7051 71.3454 25.0316 71.0742 25.2861C70.6204 25.7288 70.0588 26.0277 69.3892 26.1826C69.0295 26.2712 68.6227 26.3154 68.1689 26.3154C67.0622 26.3154 66.1242 25.9142 65.355 25.1118C64.5858 24.3039 64.2012 23.175 64.2012 21.7251C64.2012 20.2974 64.5885 19.138 65.3633 18.2471C66.138 17.3561 67.1507 16.9106 68.4014 16.9106ZM70.7837 20.8452C70.7228 20.1978 70.5817 19.6803 70.3604 19.293C69.9508 18.5736 69.2674 18.2139 68.3101 18.2139C67.6239 18.2139 67.0483 18.4629 66.5835 18.9609C66.1187 19.4535 65.8724 20.0815 65.8447 20.8452H70.7837ZM84.4219 21.0029L82.5708 15.6157L80.6035 21.0029H84.4219ZM81.7075 13.8062H83.5752L87.9995 26H86.1899L84.9531 22.3477H80.1304L78.8105 26H77.1172L81.7075 13.8062ZM89.3442 13.8062H90.8384V26H89.3442V13.8062ZM96.79 16.9106C97.4209 16.9106 98.0324 17.0601 98.6245 17.3589C99.2166 17.6522 99.6676 18.034 99.9775 18.5044C100.276 18.9526 100.476 19.4756 100.575 20.0732C100.664 20.4827 100.708 21.1357 100.708 22.0322H94.1919C94.2196 22.9342 94.4326 23.6592 94.8311 24.207C95.2295 24.7493 95.8465 25.0205 96.6821 25.0205C97.4624 25.0205 98.085 24.7632 98.5498 24.2485C98.8154 23.9497 99.0036 23.6038 99.1143 23.2109H100.583C100.545 23.5374 100.415 23.9027 100.193 24.3066C99.9775 24.7051 99.734 25.0316 99.4629 25.2861C99.0091 25.7288 98.4474 26.0277 97.7778 26.1826C97.4181 26.2712 97.0114 26.3154 96.5576 26.3154C95.4508 26.3154 94.5129 25.9142 93.7437 25.1118C92.9744 24.3039 92.5898 23.175 92.5898 21.7251C92.5898 20.2974 92.9772 19.138 93.752 18.2471C94.5267 17.3561 95.5394 16.9106 96.79 16.9106ZM99.1724 20.8452C99.1115 20.1978 98.9704 19.6803 98.749 19.293C98.3395 18.5736 97.6561 18.2139 96.6987 18.2139C96.0125 18.2139 95.437 18.4629 94.9722 18.9609C94.5073 19.4535 94.2611 20.0815 94.2334 20.8452H99.1724ZM102.592 17.1099H104.012V18.6455C104.128 18.3467 104.413 17.9842 104.867 17.5581C105.32 17.1265 105.843 16.9106 106.436 16.9106C106.463 16.9106 106.51 16.9134 106.577 16.9189C106.643 16.9245 106.757 16.9355 106.917 16.9521V18.5293C106.828 18.5127 106.745 18.5016 106.668 18.4961C106.596 18.4906 106.516 18.4878 106.427 18.4878C105.675 18.4878 105.096 18.7313 104.692 19.2183C104.288 19.6997 104.086 20.2559 104.086 20.8867V26H102.592V17.1099ZM108.511 14.6279H110.021V17.1099H111.441V18.3301H110.021V24.1323C110.021 24.4422 110.127 24.6497 110.337 24.7549C110.453 24.8158 110.647 24.8462 110.918 24.8462C110.99 24.8462 111.067 24.8462 111.15 24.8462C111.233 24.8407 111.33 24.8324 111.441 24.8213V26C111.269 26.0498 111.09 26.0858 110.901 26.1079C110.719 26.13 110.52 26.1411 110.304 26.1411C109.606 26.1411 109.133 25.964 108.884 25.6099C108.635 25.2502 108.511 24.7853 108.511 24.2153V18.3301H107.307V17.1099H108.511V14.6279Z" fill="#081F5F" />
                            <path d="M142.287 12.75H139.507V18.15H133.949V20.85H139.507V26.25H142.287V20.85H147.846V18.15H142.287V12.75ZM140.897 6C133.226 6 127 12.048 127 19.5C127 26.952 133.226 33 140.897 33C148.568 33 154.794 26.952 154.794 19.5C154.794 12.048 148.568 6 140.897 6ZM140.897 30.3C134.768 30.3 129.779 25.4535 129.779 19.5C129.779 13.5465 134.768 8.7 140.897 8.7C147.026 8.7 152.015 13.5465 152.015 19.5C152.015 25.4535 147.026 30.3 140.897 30.3Z" fill="#081F5F" />
                        </svg>
                        <svg style={{ margin: '2.5px', height:"25px", width:"110px" }} className="clickable" onClick={this.state.selectedInfoItem ? () => this.removeItem(this.state.selectedInfoItem) : null} width="175" height="33" viewBox="0 0 175 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.5" y="0.5" width="174" height="39" rx="4.5" fill="#F3F3F3" stroke="#081F5F" />
                            <path d="M28.9766 24.5889C29.5355 24.5889 29.9948 24.5308 30.3545 24.4146C30.9964 24.1987 31.5221 23.7837 31.9316 23.1694C32.2581 22.6769 32.4933 22.0461 32.6372 21.2769C32.7202 20.8175 32.7617 20.3914 32.7617 19.9985C32.7617 18.4878 32.4601 17.3146 31.8569 16.479C31.2593 15.6434 30.2936 15.2256 28.96 15.2256H26.0298V24.5889H28.9766ZM24.3696 13.8062H29.3086C30.9854 13.8062 32.2858 14.401 33.21 15.5908C34.0345 16.6644 34.4468 18.0396 34.4468 19.7163C34.4468 21.0112 34.2033 22.1816 33.7163 23.2275C32.8586 25.0758 31.3838 26 29.292 26H24.3696V13.8062ZM40.083 16.9106C40.7139 16.9106 41.3254 17.0601 41.9175 17.3589C42.5096 17.6522 42.9606 18.034 43.2705 18.5044C43.5693 18.9526 43.7686 19.4756 43.8682 20.0732C43.9567 20.4827 44.001 21.1357 44.001 22.0322H37.4849C37.5125 22.9342 37.7256 23.6592 38.124 24.207C38.5225 24.7493 39.1395 25.0205 39.9751 25.0205C40.7554 25.0205 41.3779 24.7632 41.8428 24.2485C42.1084 23.9497 42.2965 23.6038 42.4072 23.2109H43.8765C43.8377 23.5374 43.7077 23.9027 43.4863 24.3066C43.2705 24.7051 43.027 25.0316 42.7559 25.2861C42.3021 25.7288 41.7404 26.0277 41.0708 26.1826C40.7111 26.2712 40.3044 26.3154 39.8506 26.3154C38.7438 26.3154 37.8058 25.9142 37.0366 25.1118C36.2674 24.3039 35.8828 23.175 35.8828 21.7251C35.8828 20.2974 36.2702 19.138 37.0449 18.2471C37.8197 17.3561 38.8324 16.9106 40.083 16.9106ZM42.4653 20.8452C42.4045 20.1978 42.2633 19.6803 42.042 19.293C41.6325 18.5736 40.9491 18.2139 39.9917 18.2139C39.3055 18.2139 38.73 18.4629 38.2651 18.9609C37.8003 19.4535 37.554 20.0815 37.5264 20.8452H42.4653ZM45.8853 13.8062H47.3794V26H45.8853V13.8062ZM53.3311 16.9106C53.9619 16.9106 54.5734 17.0601 55.1655 17.3589C55.7576 17.6522 56.2087 18.034 56.5186 18.5044C56.8174 18.9526 57.0166 19.4756 57.1162 20.0732C57.2048 20.4827 57.249 21.1357 57.249 22.0322H50.7329C50.7606 22.9342 50.9736 23.6592 51.3721 24.207C51.7705 24.7493 52.3875 25.0205 53.2231 25.0205C54.0034 25.0205 54.626 24.7632 55.0908 24.2485C55.3564 23.9497 55.5446 23.6038 55.6553 23.2109H57.1245C57.0858 23.5374 56.9557 23.9027 56.7344 24.3066C56.5186 24.7051 56.2751 25.0316 56.0039 25.2861C55.5501 25.7288 54.9884 26.0277 54.3188 26.1826C53.9591 26.2712 53.5524 26.3154 53.0986 26.3154C51.9919 26.3154 51.0539 25.9142 50.2847 25.1118C49.5155 24.3039 49.1309 23.175 49.1309 21.7251C49.1309 20.2974 49.5182 19.138 50.293 18.2471C51.0677 17.3561 52.0804 16.9106 53.3311 16.9106ZM55.7134 20.8452C55.6525 20.1978 55.5114 19.6803 55.29 19.293C54.8805 18.5736 54.1971 18.2139 53.2397 18.2139C52.5535 18.2139 51.978 18.4629 51.5132 18.9609C51.0483 19.4535 50.8021 20.0815 50.7744 20.8452H55.7134ZM59.3906 14.6279H60.9014V17.1099H62.3208V18.3301H60.9014V24.1323C60.9014 24.4422 61.0065 24.6497 61.2168 24.7549C61.333 24.8158 61.5267 24.8462 61.7979 24.8462C61.8698 24.8462 61.9473 24.8462 62.0303 24.8462C62.1133 24.8407 62.2101 24.8324 62.3208 24.8213V26C62.1493 26.0498 61.9694 26.0858 61.7812 26.1079C61.5986 26.13 61.3994 26.1411 61.1836 26.1411C60.4863 26.1411 60.0132 25.964 59.7642 25.6099C59.5151 25.2502 59.3906 24.7853 59.3906 24.2153V18.3301H58.187V17.1099H59.3906V14.6279ZM67.5254 16.9106C68.1562 16.9106 68.7677 17.0601 69.3599 17.3589C69.952 17.6522 70.403 18.034 70.7129 18.5044C71.0117 18.9526 71.2109 19.4756 71.3105 20.0732C71.3991 20.4827 71.4434 21.1357 71.4434 22.0322H64.9272C64.9549 22.9342 65.168 23.6592 65.5664 24.207C65.9648 24.7493 66.5819 25.0205 67.4175 25.0205C68.1978 25.0205 68.8203 24.7632 69.2852 24.2485C69.5508 23.9497 69.7389 23.6038 69.8496 23.2109H71.3188C71.2801 23.5374 71.1501 23.9027 70.9287 24.3066C70.7129 24.7051 70.4694 25.0316 70.1982 25.2861C69.7445 25.7288 69.1828 26.0277 68.5132 26.1826C68.1535 26.2712 67.7467 26.3154 67.293 26.3154C66.1862 26.3154 65.2482 25.9142 64.479 25.1118C63.7098 24.3039 63.3252 23.175 63.3252 21.7251C63.3252 20.2974 63.7126 19.138 64.4873 18.2471C65.262 17.3561 66.2747 16.9106 67.5254 16.9106ZM69.9077 20.8452C69.8468 20.1978 69.7057 19.6803 69.4844 19.293C69.0749 18.5736 68.3914 18.2139 67.4341 18.2139C66.7479 18.2139 66.1724 18.4629 65.7075 18.9609C65.2427 19.4535 64.9964 20.0815 64.9688 20.8452H69.9077ZM83.5459 21.0029L81.6948 15.6157L79.7275 21.0029H83.5459ZM80.8315 13.8062H82.6992L87.1235 26H85.314L84.0771 22.3477H79.2544L77.9346 26H76.2412L80.8315 13.8062ZM88.4683 13.8062H89.9624V26H88.4683V13.8062ZM95.9141 16.9106C96.5449 16.9106 97.1564 17.0601 97.7485 17.3589C98.3407 17.6522 98.7917 18.034 99.1016 18.5044C99.4004 18.9526 99.5996 19.4756 99.6992 20.0732C99.7878 20.4827 99.832 21.1357 99.832 22.0322H93.3159C93.3436 22.9342 93.5566 23.6592 93.9551 24.207C94.3535 24.7493 94.9705 25.0205 95.8062 25.0205C96.5864 25.0205 97.209 24.7632 97.6738 24.2485C97.9395 23.9497 98.1276 23.6038 98.2383 23.2109H99.7075C99.6688 23.5374 99.5387 23.9027 99.3174 24.3066C99.1016 24.7051 98.8581 25.0316 98.5869 25.2861C98.1331 25.7288 97.5715 26.0277 96.9019 26.1826C96.5422 26.2712 96.1354 26.3154 95.6816 26.3154C94.5749 26.3154 93.6369 25.9142 92.8677 25.1118C92.0985 24.3039 91.7139 23.175 91.7139 21.7251C91.7139 20.2974 92.1012 19.138 92.876 18.2471C93.6507 17.3561 94.6634 16.9106 95.9141 16.9106ZM98.2964 20.8452C98.2355 20.1978 98.0944 19.6803 97.873 19.293C97.4635 18.5736 96.7801 18.2139 95.8228 18.2139C95.1366 18.2139 94.561 18.4629 94.0962 18.9609C93.6313 19.4535 93.3851 20.0815 93.3574 20.8452H98.2964ZM101.716 17.1099H103.136V18.6455C103.252 18.3467 103.537 17.9842 103.991 17.5581C104.444 17.1265 104.967 16.9106 105.56 16.9106C105.587 16.9106 105.634 16.9134 105.701 16.9189C105.767 16.9245 105.881 16.9355 106.041 16.9521V18.5293C105.952 18.5127 105.869 18.5016 105.792 18.4961C105.72 18.4906 105.64 18.4878 105.551 18.4878C104.799 18.4878 104.22 18.7313 103.816 19.2183C103.412 19.6997 103.21 20.2559 103.21 20.8867V26H101.716V17.1099ZM107.635 14.6279H109.146V17.1099H110.565V18.3301H109.146V24.1323C109.146 24.4422 109.251 24.6497 109.461 24.7549C109.577 24.8158 109.771 24.8462 110.042 24.8462C110.114 24.8462 110.191 24.8462 110.274 24.8462C110.357 24.8407 110.454 24.8324 110.565 24.8213V26C110.393 26.0498 110.214 26.0858 110.025 26.1079C109.843 26.13 109.644 26.1411 109.428 26.1411C108.73 26.1411 108.257 25.964 108.008 25.6099C107.759 25.2502 107.635 24.7853 107.635 24.2153V18.3301H106.431V17.1099H107.635V14.6279Z" fill="#081F5F" />
                            <path d="M139.5 6C132.034 6 126 12.0345 126 19.5C126 26.9655 132.034 33 139.5 33C146.965 33 153 26.9655 153 19.5C153 12.0345 146.965 6 139.5 6ZM139.5 30.3C133.547 30.3 128.7 25.4535 128.7 19.5C128.7 13.5465 133.547 8.7 139.5 8.7C145.454 8.7 150.3 13.5465 150.3 19.5C150.3 25.4535 145.454 30.3 139.5 30.3ZM144.347 12.75L139.5 17.5965L134.653 12.75L132.75 14.6535L137.597 19.5L132.75 24.3465L134.653 26.25L139.5 21.4035L144.347 26.25L146.25 24.3465L141.403 19.5L146.25 14.6535L144.347 12.75Z" fill="#081F5F" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    }
}